import { all, fork, call, put, takeLatest } from 'redux-saga/effects'

import { constants } from '../../modules/jobFunctions/jobSiteServiceOrderActions'
import { getAllTasks } from '../tasksSaga'
import * as api from '../../api/job/jobSiteServiceOrders'

function* jobSiteServiceOrdersRefresh(action) {
  try {
    const payload = yield call(api.getJobSiteServiceOrders, action.jobId)
    yield put({ type: constants.JOB_SITE_SERVICE_ORDERS_REFRESH.SUCCESS, payload })
    action.next && action.next(payload)
  } catch (e) {
    console.log(e)
    Raven.captureException(e)
    yield put({
      type: constants.JOB_SITE_SERVICE_ORDERS_REFRESH.FAILED,
      message: e.message || e
    })
  }
}

function* watchJobSiteServiceOrders() {
  yield takeLatest(constants.JOB_SITE_SERVICE_ORDERS_REFRESH.ACTION, jobSiteServiceOrdersRefresh)
}

function* sagaCreateJobSiteServiceOrder(action) {
  try {
    if (action.content.service_order_template_id.toString() === '')
      action.content.service_order_template_id = null
    const payload = {
      job_id: action.jobId,
      service_order_data: action.content,
      service_order_tasks: action.serviceOrderItems,
      created_by_id: action.userId,
      updated_by_id: action.userId
    }
    yield call(api.createServiceOrder, payload)
    yield put({ type: constants.JOB_SITE_SERVICE_ORDER_CREATE.SUCCESS, payload })
    yield call(jobSiteServiceOrdersRefresh, { jobId: action.jobId })
  } catch (e) {
    console.log(e)
    Raven.captureException(e)
    yield put({
      type: constants.JOB_SITE_SERVICE_ORDER_CREATE.FAILED,
      message: e.message || e
    })
  }
}

function* watchCreateJobSiteServiceOrder() {
  yield takeLatest(constants.JOB_SITE_SERVICE_ORDER_CREATE.ACTION, sagaCreateJobSiteServiceOrder)
}

function* sagaUpdateJobSiteServiceOrder(action) {
  try {
    const payload = {
      service_order_id: action.serviceOrderId,
      job_id: action.jobId,
      service_order_data: action.content,
      updated_by_id: action.userId,
      service_order_tasks: action.serviceOrderItems
    }
    yield call(api.updateServiceOrder, payload)
    yield put({ type: constants.JOB_SITE_SERVICE_ORDER_UPDATE.SUCCESS, payload })
    yield call(jobSiteServiceOrdersRefresh, { jobId: action.jobId })
  } catch (e) {
    console.log(e)
    Raven.captureException(e)
    yield put({
      type: constants.JOB_SITE_SERVICE_ORDER_UPDATE.FAILED,
      message: e.message || e
    })
  }
}

function* watchUpdateJobSiteServiceOrder() {
  yield takeLatest(constants.JOB_SITE_SERVICE_ORDER_UPDATE.ACTION, sagaUpdateJobSiteServiceOrder)
}

function* sagaDeleteJobSiteServiceOrder(action) {
  try {
    const payload = {
      service_order_id: action.serviceOrderId
    }
    yield call(api.deleteServiceOrder, payload)
    yield put({ type: constants.JOB_SITE_SERVICE_ORDER_DELETE.SUCCESS, payload })
    yield call(jobSiteServiceOrdersRefresh, { jobId: action.jobId })
  } catch (e) {
    console.log(e)
    Raven.captureException(e)
    yield put({
      type: constants.JOB_SITE_SERVICE_ORDER_DELETE.FAILED,
      message: e.message || e
    })
  }
}

function* watchDeleteJobSiteServiceOrder() {
  yield takeLatest(constants.JOB_SITE_SERVICE_ORDER_DELETE.ACTION, sagaDeleteJobSiteServiceOrder)
}

function* getServiceOrderItems(action) {
  try {
    const payload = yield call(api.getJobSiteServiceOrderItems, action.serviceOrderId)
    yield put({ type: constants.GET_SERVICE_ORDER_ITEMS.SUCCESS, payload })
  } catch (e) {
    console.log(e)
    Raven.captureException(e)
    yield put({
      type: constants.GET_SERVICE_ORDER_ITEMS.FAILED,
      message: e.message || e
    })
  }
}

function* watchGetServiceOrderItems() {
  yield takeLatest(constants.GET_SERVICE_ORDER_ITEMS.ACTION, getServiceOrderItems)
}

function* markTaskComplete(action) {
  try {
    yield call(api.markTaskComplete, action.taskId)
    yield put({ type: constants.MARK_TASK_COMPLETE.SUCCESS, data: 'OK' })
    yield call(getServiceOrderItems, { serviceOrderId: action.serviceOrderId })
    yield call(jobSiteServiceOrdersRefresh, { jobId: action.jobId })
  } catch (e) {
    console.log(e)
    Raven.captureException(e)
    yield put({
      type: constants.MARK_TASK_COMPLETE.FAILED,
      message: e.message || e
    })
  }
}

function* watchMarkTaskCompletes() {
  yield takeLatest(constants.MARK_TASK_COMPLETE.ACTION, markTaskComplete)
}

function* sagaQuickAddTask(action) {
  try {
    const payload = {
      name: action.task.name,
      type: action.task.type,
      created_by_id: action.userId,
      updated_by_id: action.userId
    }
    yield call(api.quickAddTask, payload)
    yield put({ type: constants.QUICK_ADD_TASK.SUCCESS, payload })
    yield call(getAllTasks)
  } catch (e) {
    console.log(e)
    Raven.captureException(e)
    yield put({
      type: constants.QUICK_ADD_TASK.FAILED,
      message: e.message || e
    })
  }
}

function* watchQuickAddTask() {
  yield takeLatest(constants.QUICK_ADD_TASK.ACTION, sagaQuickAddTask)
}

export function* rootSaga() {
  // add more sagas here
  yield all([
    fork(watchJobSiteServiceOrders),

    fork(watchCreateJobSiteServiceOrder),
    fork(watchUpdateJobSiteServiceOrder),
    fork(watchDeleteJobSiteServiceOrder),

    fork(watchGetServiceOrderItems),
    fork(watchMarkTaskCompletes),

    fork(watchQuickAddTask)
  ])
}



// WEBPACK FOOTER //
// ./src/redux/sagas/jobFunctions/jobSiteServiceOrderSaga.js